export enum SearchTabText {
    PROGRAMMES = 'Programmes',
    UNIVERSITIES = 'Universities',
    SCHOLARSHIPS = 'Scholarships',
}